class CartPage extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.querySelector('[data-cart-line-item-status]') || document.querySelector('[data-cart-drawer-line-item-status]');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = window.debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate(event);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?sections=cart-drawer,cart-count`)
        .then((response) => response.text())
        .then((responseText) => {
          const parsedState = JSON.parse(responseText);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            let getSectionInnerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);

            if (!elementToReplace || !getSectionInnerHTML) {
              return;
            }

            if (section.id === 'cart-count') {
              if (window.creatorSettings.header.cartIconCountStyle === 'number' && window.creatorSettings.header.enableCartIcon) {
                getSectionInnerHTML = getSectionInnerHTML.replace('(', '').replace(')', '');
              }
            }

            elementToReplace.innerHTML = getSectionInnerHTML;
          }));
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }


  onChange(event) {
    const line = event.target.dataset.index;
    const quantity = event.target.value;
    const name = document.activeElement.getAttribute('name');
    const variantId = event.target.dataset.quantityVariantId;
    this.updateQuantity(line, quantity, name, variantId);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-items',
        section: 'cart-items',
        selector: '[data-cart-items]'
      },
      {
        id: 'cart-subtotal',
        section: 'cart-subtotal',
        selector: '[data-cart-subtotal]'
      },
      {
        id: 'cart-count',
        section: 'cart-count',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_change_url}`, {...window.fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const quantityElement = document.querySelector(`[data-cart-item-quantity-input="${line}"]`);
        const items = document.querySelectorAll('.cart-item');
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartDrawerWrapper = document.querySelector('cart-drawer');

        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        }
    
        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;

        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }

        this.updateLiveRegions(line, message);

        const cartCountIcon = document.querySelector('[data-cart-count-icon]');
        const cartCountValue = document.querySelector('[data-cart-count-value]');

        if (cartCountIcon && cartCountValue) {
          cartCountValue.innerHTML = cartCountValue.innerHTML.replace('(', '').replace(')', '');
        }

        const cartCountBadge = document.querySelector('[data-cart-count-badge]');

        if (cartCountBadge) {
          if (parsedState.item_count === 0) {
            cartCountBadge.classList.remove('active');
          } else {
            cartCountBadge.classList.add('active');
          }
        }

        const lineItem = document.querySelector(`[data-cart-item="${line}"]`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? window.trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          window.trapFocus(cartDrawerWrapper.querySelector('[data-cart-drawer-inner-empty]'), cartDrawerWrapper.querySelector('a'));

          const cartCountBadge = document.querySelector('[data-cart-count-badge]');

          if (cartCountBadge) {
            cartCountBadge.classList.remove('active');
          }
        } else if (document.querySelector('[data-cart-item]') && cartDrawerWrapper) {
          window.trapFocus(cartDrawerWrapper, document.querySelector('[data-cart-item]'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

      }).catch(() => {
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      }).finally(() => {
        this.disableLoading();
      });;
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.querySelector(`[data-cart-item-error="${line}"]`);

    if (lineItemError) {
      lineItemError.innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading() {
    const cartContent = document.querySelector('[data-cart-content]') || document.querySelector('[data-cart-drawer-content]');
    cartContent.classList.add('cart__content--disabled');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartContent = document.querySelector('[data-cart-content]') || document.querySelector('[data-cart-drawer-content]');
    cartContent.classList.remove('cart__content--disabled');
  }
}

customElements.define('cart-page', CartPage);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-page') || this.closest('cart-drawer-items');

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', window.debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${window.routes.cart_update_url}`, {...window.fetchConfig(), ...{ body }});
    }, 300));
  }
}

customElements.define('cart-note', CartNote);